import { financialRecordRepo } from '../repo';

export const financialRecordService = {
    async getAll(params = {}) {
        try {
            const response = await financialRecordRepo.getAll(params);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async getById(financialId) {
        if (!financialId) {
            throw new Error('Financial record ID is required');
        }

        try {
            const response = await financialRecordRepo.getById(financialId);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async getByShop(shopId) {
        if (!shopId) {
            throw new Error('Shop ID is required');
        }

        try {
            const response = await financialRecordRepo.getByShop(shopId);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async getAllByShop(shopId, params = {}) {
        if (!shopId) {
            throw new Error('Shop ID is required');
        }

        try {
            const response = await financialRecordRepo.getAllByShop(
                shopId,
                params
            );

            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async getTotalByShop(shopId) {
        if (!shopId) {
            throw new Error('Shop ID is required');
        }

        try {
            const response = await financialRecordRepo.getTotalByShop(shopId);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async getTransactionsByShop(shopId, params = {}) {
        if (!shopId) {
            throw new Error('Shop ID is required');
        }

        try {
            const response = await financialRecordRepo.getTransactionsByShop(
                shopId,
                params
            );

            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async create(data) {
        if (!data.shopId) {
            throw new Error('Shop ID is required');
        }

        if (!data.category) {
            throw new Error('Category is required');
        }

        if (!['expense', 'receive'].includes(data.category)) {
            throw new Error('Category must be expense or receive');
        }

        if (!data.amount || Number(data.amount) <= 0) {
            throw new Error('Valid amount is required');
        }

        if (!data.added_date) {
            throw new Error('Added date is required');
        }

        try {
            const response = await financialRecordRepo.create(data);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async update(financialId, data) {
        if (!financialId) {
            throw new Error('Financial record ID is required');
        }

        try {
            const response = await financialRecordRepo.update(
                financialId,
                data
            );

            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async toggleStatus(financialId) {
        if (!financialId) {
            throw new Error('Financial record ID is required');
        }

        try {
            const response =
                await financialRecordRepo.toggleStatus(financialId);

            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async getStats(params = {}) {
        try {
            const response = await financialRecordRepo.getAll({
                per_page: 1000,
                ...params,
            });

            const records = response.data?.data || [];

            const totalReceive = records
                .filter(record => record.category === 'receive')
                .reduce(
                    (sum, record) => sum + parseFloat(record.amount || 0),
                    0
                );

            const totalExpense = records
                .filter(record => record.category === 'expense')
                .reduce(
                    (sum, record) => sum + parseFloat(record.amount || 0),
                    0
                );

            return {
                total: records.length,
                total_receive: totalReceive,
                total_expense: totalExpense,
                balance: totalReceive - totalExpense,
                active: records.filter(
                    record => record.status === 'active'
                ).length,
                inactive: records.filter(
                    record => record.status === 'inactive'
                ).length,
            };
        } catch (error) {
            throw this.handleError(error);
        }
    },

    handleError(error) {
        console.error('FinancialRecordService Error:', error);
        return error.response?.data || error;
    },
};